//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 支持slot=default slot=left slot=right slot=content，当default存在时，其他3个将失效
 */
export default {
  name: 'ListItem',
  props: {
    /**
     * 边距样式 normal/small
     */
    padding: {
      type: String,
      "default": 'normal'
    }
  }
};